import React, { useContext, useEffect, useState } from "react";
import { Redirect, useRouteMatch, useHistory } from "react-router-dom";
import axios from "axios";
import { CircularProgress, Box } from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import queryString from "query-string";
import LoginError from "./LoginError";

function LoginPage() {
  const [redirectToPatientDetails, setRedirectToPatientDetails] = useState("");
  const [loadingCompleted, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const { changeUser } = useContext(AuthContext);
  const match = useRouteMatch();
  const history = useHistory();

  const getRedirectQueryString = function (redirectTo) {
    let qs = { redirectTo };
    return `?${queryString.stringify(qs)}`;
  };
  const setRefreshToken = (data) => {
    localStorage.setItem("accessToken", data.accessToken);
    localStorage.setItem("refreshToken", data.refreshToken);
    localStorage.setItem("userId", data.userid);

    if (!data.isTermAndConditionAccepted) {
      let url = `/privacypolicy${getRedirectQueryString(
        `/patients/${data.patientId}/1`
      )}`;
      history.push(url);
    } else {
      setRedirectToPatientDetails(`/patients/${data.patientId}/1`);
    }
    setLoading(true);
  };

  useEffect(() => {
    const getAccessToken = async () => {
      let response;
      try {
        let token = match.params.token;
        response = await axios.post("/api/userauthservice/login", {
          token,
        });
        if (response && response.status === 200) {
          localStorage.setItem("loginBy", "sso");
          localStorage.setItem("addedThroughSource", "sso");
          await changeUser({
            userId: response.data.userid,
            refreshToken: response.data.refreshToken,
          });
          setRefreshToken(response.data);
        } else {
          setError(true);
        }
      } catch (error) {
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 400)
        ) {
          let localStorageRefreshToken = localStorage.getItem("refreshToken");
          if (localStorageRefreshToken) {
            let result = axios.post(
              "/api/userauthservice/accessTokenByRefershToken",
              { refreshToken: localStorageRefreshToken }
            );
            if (result && result.status === 200) {
              localStorage.setItem("loginBy", "sso");
              setRefreshToken(result.data);
            } else {
              setError(true);
            }
          } else {
            setError(true);
          }
        } else {
          setError(true);
        }
      }
    };
    getAccessToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      {loadingCompleted && !isError ? (
        <Redirect
          to={{
            pathname: `${redirectToPatientDetails}`,
            state: { addBy: "sso" },
          }}
        />
      ) : !isError ? (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <LoginError />
      )}
    </Box>
  );
}
export default LoginPage;
